import { createFileRoute } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { useCatalogExportType } from '~/features/exports/hooks/use-catalog-export-type';
import { useMainScrollReset } from '~/features/exports/hooks/use-main-scroll-reset';

// Explicit dynamic import — see `../exports/$exportId.tsx` for why.
const ExportProfilePage = lazy(() =>
  import('~/features/exports/export-profiles/pages/export-profile-page').then((m) => ({
    default: m.ExportProfilePage,
  })),
);

/** One export profile's own page: settings, schedule, KPIs and its runs table. Ungated —
 *  see `../exports/$exportId.tsx`. */
export const Route = createFileRoute('/_authenticated/_tenant/exports/catalog/profiles/$profileId')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  useCatalogExportType();
  useMainScrollReset();
  const { profileId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ExportProfilePage profileId={profileId} />
    </Suspense>
  );
}
